define('TescoMobile_FamilyBubble/js/view/upgrade-modal-options',['TescoMobile_Checkout/js/view/upgrade-modal-options', 'jquery', 'ko', 'Magento_Ui/js/modal/modal', 'Magento_Customer/js/customer-data', 'mage/url', 'TescoMobile_Checkout/js/action/get-subscriptions-info', 'mage/translate', 'catalogAddToCart'], function (Component, $, ko, modal, customerData, urlBuilder, actionGetSubscriptionsInfo, $t) {
  'use strict';

  return Component.extend({
    messageUpgradeFamilyLocked: $t('You can\'t upgrade this line to a Family Pack \'everyday price\' deal. Go back to choose a different deal.'),
    messageUpgradeReduceFamilyLocked: $t('You can\'t upgrade this line to a Family Pack \'family discount\' price deal. You need to keep an \'everyday price\' line in your Family Pack.'),
    messageFamilyLocked: $t('You can\'t add another Family Pack \'everyday price\' deal to your account. Go back to choose a different deal.'),
    familyBubbleLocked: ko.observable(false),
    familyBubbleReducePriceLocked: ko.observable(false),
    isActionButtonLocked: ko.observable(false),
    isLoggedOnAddToCart: ko.observable(false),
    isAddToCartAction: ko.observable(false),
    initialize: function () {
      this._super();
      let self = this;
      $('body').on('customer-login-paym add-new-contract add-to-cart-upgrade', function () {
        self.isAddToCartAction(true);
      });
      $('body').on('otac-ajax-logged-in-success', function () {
        self.isLoggedOnAddToCart(true);
      });
      $('body').on('upgrade-popup-closed', function () {
        if (self.isFamilyBubbleEligible() && self.isLoggedOnAddToCart() && self.isAddToCartAction() === false) {
          location.reload();
        }
      });
      $('body').on('upgrade-options-submited', function (e) {
        if (this.subscriptionsLoaded() === true) {
          this.isLoading(false);
        }
      }.bind(this));
      $('body').on('add-to-cart-button-change-state', function (event) {
        this.isActionButtonLocked(Boolean(event === null || event === void 0 ? void 0 : event.enabled));
      }.bind(this));
    },
    initObservable: function () {
      this._super().observe(['familyBubbleLocked', 'familyBubbleReducePriceLocked']);
      return this;
    },
    isFamilyBubbleEligible: function () {
      var customer = customerData.get('customer');
      return !!customer().family_bubble_eligible;
    },
    setAlternativeUrl: function () {
      if (this.familyBubbleLocked()) {
        window.location.href = urlBuilder.build('customer/familybubble/alternativereduce');
      } else {
        window.location.href = urlBuilder.build('customer/familybubble/alternativefull');
      }
    },
    getSubMessage: function () {
      return this.familyBubbleReducePriceLocked() ? this.messageUpgradeReduceFamilyLocked : this.messageUpgradeFamilyLocked;
    },
    getSubscriptionsInfo: function (form) {
      let element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      let type = $(form).find('input[name=deal-contract-type]').val(),
        familyBubbleFullPrice = $(form).find('input[name=family_bubble_full_price]').val(),
        familyBubbleReducePrice = $(form).find('input[name=family_bubble_reduce_price]').val();
      this.subscriptionsLoaded(false);
      if (form === undefined) {
        type = $('form').find('input[name=deal-contract-type]').val(), familyBubbleFullPrice = $('form').find('input[name=family_bubble_full_price]').val(), familyBubbleReducePrice = $('form').find('input[name=family_bubble_reduce_price]').val();
      }
      this.familyBubbleLocked(familyBubbleFullPrice && this.isFamilyBubbleEligible());
      this.familyBubbleReducePriceLocked(familyBubbleReducePrice && this.isFamilyBubbleEligible());
      actionGetSubscriptionsInfo(type).done(function (result) {
        this.subscriptionsInfo(JSON.parse(result)['subscriptions']);
        this.contractEnds(JSON.parse(result)['contract_end_time_text']);
        this.subscriptionsLimit(JSON.parse(result)['subscriptions_limit']);
        this.countSubscriptions(JSON.parse(result)['count_subscriptions']);
      }.bind(this)).fail(function (response) {
        console.log(response);
      }.bind(this)).always(function (response) {
        this.subscriptionsLoaded(true);
        this.isLoading(false);
      }.bind(this));
    }
  });
});

